import * as React from 'react';

import AdminUploadedFileDetail from './AdminUploadedFileDetail';
import Dialog from 'components/Dialog';

import { AutoMessageFileUpload } from 'admin/components/AdminUploadedFiles/AdminUploadedFilesView';

type Props = {
  fileUpload: AutoMessageFileUpload;
  onClose: () => void;
};

function AdminUploadedFileDetailModal(props: Props) {
  return (
    <Dialog size="medium" onRequestHide={props.onClose}>
      <AdminUploadedFileDetail fileUpload={props.fileUpload} />
    </Dialog>
  );
}

export default AdminUploadedFileDetailModal;
